import { render, staticRenderFns } from "./ElementAdIcons.vue?vue&type=template&id=35337994"
import script from "./ElementAdIcons.vue?vue&type=script&lang=js"
export * from "./ElementAdIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports